import { THIRD_PARTY_ROLE_TYPE_LABELS } from "@Front/Utils/thirdPartyRoles";
import { organizationOfPhrase, organizationSubject, workspaceAllLabel, workspaceOfPhrase, workspaceSearchOfPhrase } from "@Front/Utils/publicSiteBranding";
import { COMMON_UI_I18N_FOLDER_STATUS_MESSAGES } from "./commonUiI18nFolderStatusMessages";
import { COMMON_UI_I18N_PART1_SLICE_A_DEED_TYPE_THIRD_PARTY } from "./commonUiI18nPart1_sliceADeedTypeThirdParty";

/** Slice A of COMMON_UI_I18N_PART1 — modal through deedTypeListSettings */
export const COMMON_UI_I18N_PART1_SLICE_A = {
	modal: {
		cancelCta: "Annuler",
		confirmCta: "Confirmer",
		errorTitle: "Erreur",
	},
	feedbackMessages: {
		successTitle: "Succès !",
		errorTitle: "Erreur",
		warningTitle: "Information",
		createSuccessDescription: "Création effectuée avec succès.",
		updateSuccessDescription: "Mise à jour effectuée avec succès.",
		publishSuccessDescription: "Publication effectuée avec succès.",
		archiveSuccessDescription: "Archivage effectué avec succès.",
		unexpectedError: "Une erreur inattendue s'est produite. Réessayez ou contactez le support en indiquant l'action effectuée.",
		currentOfficeUnknown: `Impossible d'identifier ${organizationSubject()} en cours.`,
		saveFailed: "L'enregistrement n'a pas abouti.",
		loadFailed: "Le chargement de l'élément n'a pas abouti.",
		selectValidRole: "Veuillez sélectionner un rôle valide.",
		adminRoleNotFound: "Le rôle administrateur est introuvable.",
		defaultRoleNotFound: "Le rôle par défaut est introuvable.",
		updateStakeholdersError: "La mise à jour des collaborateurs du dossier n'a pas abouti.",
		ribLoadError: `Le chargement du RIB ${organizationOfPhrase()} n'a pas abouti.`,
		ribUpdateError: "La mise à jour du RIB n'a pas abouti.",
		ribDeleteError: "La suppression du RIB n'a pas abouti.",
		resendCodeError: "L'envoi du code de connexion au tiers n'a pas abouti.",
		sendLoginCodeError: "L'envoi du code de connexion au client n'a pas abouti.",
		loadParametrageError: "Le chargement du paramétrage n'a pas abouti.",
		saveParametrageError: "L'enregistrement du paramétrage n'a pas abouti.",
		loadOfficeError: `Le chargement des informations ${organizationOfPhrase()} n'a pas abouti.`,
		searchOfficesError: `La recherche ${workspaceSearchOfPhrase()} n'a pas abouti.`,
		searchNotaryError: "La recherche de notaires n'a pas abouti.",
		thirdPartyOrFolderUidMissing: "UID du tiers ou du dossier manquant",
	},
	actions: {
		validateCta: "Valider",
		deleteCta: "Supprimer",
		removeCta: "Retirer",
		saveCta: "Enregistrer",
		createCta: "Créer",
		addCta: "Ajouter",
		continueCta: "Continuer",
		quitCta: "Quitter",
	},
	formLabels: {
		firstName: "Prénom",
		firstNameRequired: "Prénom *",
		lastName: "Nom",
		lastNameRequired: "Nom *",
		email: "E-mail",
		emailRequired: "E-mail *",
		phoneRequired: "Téléphone *",
		phoneLabel: "Numéro de téléphone",
		birthdateLabel: "Date de naissance (facultatif)",
		birthdatePlaceholder: "Date de naissance",
		addressLabel: "Adresse (facultatif)",
		addressPlaceholder: "Adresse",
		company: "Société",
		companyName: "Nom de l'entreprise",
		roleType: "Type de rôle",
		officeName: `Nom ${organizationOfPhrase()}`,
		invitedNotaryShareReadOnlyLabel: "Confrère invité",
		noteClient: "Note à l'attention du client",
		roleName: "Nom du rôle",
		deedTypeName: "Nom de l'acte",
		description: "Description",
		documentNameLabel: "Nom du document",
		privateDescriptionLabel: `Description visible par les collaborateurs ${workspaceOfPhrase()}`,
		publicDescriptionLabel: `Description visible par les clients ${workspaceOfPhrase()}`,
	},
	folder: {
		createFolderCta: "Créer un dossier",
		archiveFolderCta: "Archiver le dossier",
		unarchiveFolderCta: "Désarchiver le dossier",
		deleteFolderCta: "Supprimer le dossier",
		sendDocumentsCta: "Envoyer des documents",
		verifyDocumentCta: "Vérifier un document",
		editCollaboratorsCta: "Modifier les collaborateurs",
		editInformationCta: "Modifier les informations du dossier",
		remindCta: "Relancer",
		reminderAllDocumentsLabel: "Tous les documents",
		pushToInotCta: "Envoyer sur iNot",
		refuseCta: "Refuser",
		sectionsConfreres: "Confrères",
		sectionsClients: "Clients",
		sectionsThirdParties: "Acteurs tiers",
		sectionsDocumentsSent: "Documents envoyés",
		sectionsAskDocuments: "Demander des documents",
		sectionsViewDocument: "Visualiser le document",
		collaboratorsAllOffice: workspaceAllLabel(),
		collaboratorsSelect: "Sélectionner des collaborateurs",
		collaboratorsLabel: "Collaborateurs",
		modalConfirmSaveChanges: "Enregistrer les modifications ?",
		modalDeleteDocumentRequest: "Supprimer la demande de document ?",
		modalClientRemoveMessage: "Le client sera retiré du dossier.",
		modalThirdPartyRemoveMessage: "Le tiers sera retiré du dossier.",
		modalSharedNotaryRemoveMessage: "Le notaire invité sera retiré du dossier.",
		modalClientFolderCompletion: "Complétion du dossier client",
		modalDocumentsRequested: "Documents demandés",
		modalDocumentsToValidate: "Documents à valider / validés",
		selectDocumentAria: "Sélectionner le document",
		tagNonConforme: "NON CONFORME",
		documentNameColumnTitle: "Nom du document",
		trashTitle: "Corbeille",
		trashCountLabel: "dossier(s) supprimé(s)",
		trashInfoMessage: COMMON_UI_I18N_FOLDER_STATUS_MESSAGES.trash.infoMessage,
		quitWithoutSavingTitle: "Quitter sans enregistrer ?",
		quitWithoutSavingMessage: "Si vous quittez, toutes les modifications que vous avez effectuées ne seront pas enregistrées.",
		quitWithoutSavingConfirmCta: "Oui, quitter sans enregistrer",
		participantSummaryGuestClient: "Client invité",
		participantSummaryGuestThirdParty: "Tiers invité",
		participantSummaryInvitedNotary: "Notaire invité",
		contactEmailNotProvidedShort: "E-mail non renseigné",
		invitedNotaryDraftContactUnknownLabel: "Contact inconnu",
		invitedNotarySharingDisplayFallbackLabel: "Notaire invité",
		invitedNotaryInvitedOnOfficeLabel: "Invité sur l'étude",
		documentStatusAsked: "Demandé",
		documentStatusDeposited: "À valider",
		documentStatusValidated: "Validé",
		documentStatusRefused: "Refusé",
		documentStatusSent: "Envoyé",
		documentStatusDownloaded: "Téléchargé",
		documentStatusNonConforme: "Non conforme",
		downloadSelectedZipDefaultLabel: "Télécharger le ZIP de tous les documents sélectionnés",
		downloadSelectedCertificateDefaultLabel: "Télécharger le Certificat de tous les documents sélectionnés",
		downloadInProgressLabel: "Téléchargement en cours...",
		documentPreviewAlt: "Aperçu du document",
		unavailableFileDepositDateLabel: "Date de dépôt : {date}",
		unavailableFileExpirationDateLabel: "Date d'expiration : {date}",
		unavailableFileDateUnknown: "Non renseignée",
		unavailableFileDownloadBlockedToast: "Le fichier n'est plus disponible sur le serveur.",
	},
	thirdPartyRoleTypeLabels: THIRD_PARTY_ROLE_TYPE_LABELS,
	deedTypes: {
		selectDocuments: "Sélectionner des documents",
		saveChangesConfirm: "Enregistrer les modifications ?",
		saveChangesBody: "La description et les documents seront enregistrés pour ce type d'acte.",
		listBackMobile: "Liste des types d'actes",
		createTitle: "Créer un type d'acte",
		editTitle: "Modifier les informations d'un acte",
		namePlaceholder: "Nom de l'acte",
		descriptionPlaceholder: "Description",
		parametragePieceListsTitle: "Paramétrage des listes de pièces",
	},
	roles: {
		listBackMobile: "Liste des rôles",
		createTitle: "Créer un rôle",
		roleNamePlaceholder: "Nom du rôle",
		modalConfirmSave: "Êtes-vous sûr d'enregistrer ?",
	},
	documentsReminder: {
		clientLabel: "Client",
		itemsPerPageLabel: "Items par page",
		perPageSuffix: " par page",
	},
	backNav: {
		listCollaborators: "Liste des collaborateurs",
		listRoles: "Liste des rôles",
		listDeedTypes: "Liste des types d'actes",
		listDocumentTypes: "Liste des documents",
		listPieceLists: "Liste des listes de pièces",
		listFolders: "Liste des dossiers",
		back: "Retour",
		backToDocuments: "Retour aux documents",
		backToFolders: "Retour aux dossiers",
		disconnect: "Déconnexion",
	},
	navigationMenu: {
		office: {
			collaborators: "Collaborateurs",
			clientsBase: "Base clients",
			thirdPartiesBase: "Base des tiers",
			confreresBase: "Base des confrères",
			rolesManagement: "Gestion des rôles",
			deedTypesSettings: "Paramétrage des listes de pièces",
			remindersSettings: "Paramétrage des relances",
			cnilSettings: "Paramétrage CNIL",
			officeRib: "RIB Office",
			subscription: "Abonnement",
		},
		superAdmin: {
			usersManagement: "Gestion des utilisateurs",
			officesManagement: "Gestion des offices",
			dashboard: "Dashboard",
			officeSeats: "Sièges par bureau",
			subscriptionPlans: "Gestion des forfaits",
		},
		common: {
			workspaceSuperAdmin: "Espace super admin",
			workspaceOffice: "Espace office",
			myFolders: "Mes dossiers",
			myAccount: "Mon compte",
			userGuide: "Guide de Prise en Main",
			support: "Support",
			cgu: "CGU",
			closeMenuAriaLabel: "Close menu",
		},
	},
	deedTypeListSettings: {
		sectionTitleAi: "AI",
		accessibleAiLabel: "Accessible AI",
		optionNo: "Non",
		optionYes: "Oui",
		sectionTitleCnil: "CNIL",
		cnilRetentionYearsLabel: "Délai avant suppression automatique (années)",
		cnilRetentionPlaceholder: "20",
		cnilCollectionReasonLabel: "Raison de la collecte (option)",
		cnilUsageLabel: "Usage des données collectées (option)",
		sectionTitleReminders: "Relances métier (attente statut déposé / téléchargé / envoyé / supprimé)",
		remindersHelpText: "Délais en jours depuis la création de la demande de document. Relance des membres par mail (Mailchimp).",
		reminderDelayPlaceholder: "Jours",
		reminderDelay1Label: "Délai avant 1ère relance (option)",
		reminderDelay2Label: "Délai avant 2e relance (option)",
		reminderDelay3Label: "Délai avant 3e relance (option)",
		reminderDelay4Label: "Délai avant 4e relance (option)",
		reminderDelay5Label: "Délai avant 5e relance (option)",
		sectionTitleAlertSince: "Alertes métier depuis la création du dossier",
		alertSince1DaysLabel: "Délai avant 1ère alerte (jours, option)",
		alertSince2DaysLabel: "Délai avant 2e alerte (jours, option)",
		alertSince3DaysLabel: "Délai avant 3e alerte (jours, option)",
		alertSince1TextLabel: "Texte alerte 1 (option)",
		alertSince2TextLabel: "Texte alerte 2 (option)",
		alertSince3TextLabel: "Texte alerte 3 (option)",
		sectionTitleAlertBefore: "Alertes métier avant une date butoir",
		alertBefore1DaysLabel: "Délai avant 1ère relance (jours, option)",
		alertBefore2DaysLabel: "Délai avant 2e relance (jours, option)",
		alertBefore3DaysLabel: "Délai avant 3e relance (jours, option)",
		alertBefore1TextLabel: "Texte alerte 1 (option)",
		alertBefore2TextLabel: "Texte alerte 2 (option)",
		alertBefore3TextLabel: "Texte alerte 3 (option)",
		dateButoir1Option: "Date butoir 1 (option)",
		dateButoir2Option: "Date butoir 2 (option)",
		dateButoir3Option: "Date butoir 3 (option)",
		...COMMON_UI_I18N_PART1_SLICE_A_DEED_TYPE_THIRD_PARTY,
		saveButtonLoading: "Enregistrement…",
		saveButtonSubmit: "Enregistrer le paramétrage",
	},
} as const;
